<template>
  <div class="shaddow-footer">
    <v-footer app color="white" class="overall" v-if="visible">
      <v-container class="px-0">
        <TheHeaderMenu :footer="true" />
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import TheHeaderMenu from '@/components/TheHeaderMenu'
export default {
  components: {
    TheHeaderMenu,
  },
  computed: {
    route() {
      return this.$route.path
    },
    visible() {
      const r = this.$route.path.split('/')
      if (r[2] && r[2] !== 'quiz') {
        return false
      }
      return true
    },
  },
}
</script>

<style>
.overall {
  z-index: 210 !important;
  box-shadow: 0 -10px 8px 2px rgba(0, 0, 0, 0.1) !important;
}

.shaddow-footer {
  
}
</style>
